import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { useNavigationController } from "@firecms/core";
import { Paper, Typography } from "@firecms/ui";
import { buildCollectionSearch, fetchHomeStatValue, type HomeStat } from "./collection_counts";

function formatCount(value: number | null): string {
    if (value === null) {
        return "–";
    }
    return value.toLocaleString("tr-TR");
}

function StatCard({
    stat,
    value,
}: {
    stat: HomeStat;
    value: number | null | undefined;
}) {
    const navigation = useNavigationController();
    const display = value === undefined ? "…" : formatCount(value);
    const card = (
        <Paper className="h-full p-4">
            <Typography variant="caption" color="secondary">
                {stat.label}
            </Typography>
            <Typography variant="h4" className="mt-1">
                {display}
            </Typography>
        </Paper>
    );

    if (!stat.collectionPath) {
        return card;
    }

    const path = navigation.buildUrlCollectionPath(stat.collectionPath);
    const search = buildCollectionSearch(stat.filter);
    const to = search ? `${path}?${search}` : path;

    return (
        <Link
            to={to}
            className="block no-underline text-inherit hover:opacity-90"
        >
            {card}
        </Link>
    );
}

/**
 * Anasayfa üst şeridi. Tek kart izin hatasında "–" gösterir; diğerleri durur.
 */
export function HomeStats({ stats }: { stats: HomeStat[] }) {
    const [values, setValues] = useState<Record<string, number | null>>({});

    useEffect(() => {
        let cancelled = false;
        for (const stat of stats) {
            fetchHomeStatValue(stat)
                .then((count) => {
                    if (!cancelled) {
                        setValues((current) => ({ ...current, [stat.key]: count }));
                    }
                })
                .catch((error) => {
                    // Genelde eksik composite index; Firebase hata mesajında create linki gelir.
                    console.error(`HomeStats "${stat.key}" sayacı başarısız:`, error);
                    if (!cancelled) {
                        setValues((current) => ({ ...current, [stat.key]: null }));
                    }
                });
        }
        return () => {
            cancelled = true;
        };
    }, [stats]);

    return (
        <div className="mb-6 grid grid-cols-2 gap-3 md:grid-cols-3 xl:grid-cols-4">
            {stats.map((stat) => (
                <StatCard key={stat.key} stat={stat} value={values[stat.key]} />
            ))}
        </div>
    );
}
